export function getCurrency () {
  return process.env.VUE_APP_CURRENCY || '₽'
}

export function getCurrencySymbol () {
  return process.env.VUE_APP_CURRENCY_SYMBOL || '₽'
}
